import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { Devices } from 'src/app/modules/entry-control/interfaces/devices';
import { Facility } from 'src/app/modules/entry-control/interfaces/facility';

@Component({
  selector: 'app-edit-tags',
  templateUrl: './edit-tags.component.html',
  styleUrls: ['./edit-tags.component.css']
})
export class EditTagsComponent implements OnInit, OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.dataId > 0) {
      this.get(this.dataId);
    } else {
      this.modal.dismissAll();
    }
  }
  ngOnInit(): void {
    this.getFacility();
    if (this.dataId > 0) {
      this.dataId;
      this.get(this.dataId);
    } else {
      this.modal.dismissAll();
    }
  }
  @Input()
  dataId: number = 0;

  @Output()
  success = new EventEmitter<boolean>();
  @Output()
  record = new EventEmitter<Devices>();
  
  facilityes:Facility[];

  id: number = 0;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    code: new UntypedFormControl(''),
    tag: new UntypedFormControl(''),
    location: new UntypedFormControl(''),
    facility_id: new UntypedFormControl(0),
    state_id: new UntypedFormControl(0),
  });
  get(id: number) {
    this.api.getTag(id).subscribe(
      (response) => {
        this.form.patchValue(response.data);
      },
      (error) => {
        this.toast.warning(error.error.mistakes,error.error.msg);
        this.modal.dismissAll();
      }
    );
  }
  getFacility() {
    this.api.getAllFacility().subscribe((res) => {
      this.facilityes = res.data as Facility[];
    });
  }
  update() {
    this.api.updateTags(this.form).subscribe(
      (response) => {
        this.toast.success(
          response.msg,
          'Gestión Dispositivos'
        );
        this.record.emit(response.data as Devices);
        this.success.emit(true);
          this.modal.dismissAll();
      },
      (error) => {
        this.toast.warning(error.error.mistakes, 'Tenemos un error',{
          enableHtml:true,
          closeButton:true
        });
      }
    );
  }
  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
}
